import React, { useState } from "react";
import { ThumbLikeRegular, ThumbLikeFilled, ThumbDislikeRegular, ThumbDislikeFilled } from "@fluentui/react-icons"; // Assuming you're using Fluent UI icons
import { makeStyles, Label } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { shorthands } from "@griffel/react";

const useStyles = makeStyles({
  feedbackContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    ...shorthands.padding("0px"),
    width: "262px",
    height: "26px",
    ...shorthands.flex("none"),
    order: 2,
    alignSelf: "stretch",
    flexGrow: 0,
   /* opacity: "0.3",
    transition: "opacity 0.3s ease", // Add transition for smooth effect
    "&:hover": {
      // Apply styles on hover
      opacity: 1,
    },*/
  },
  iconStyle: {
    width: "16px",
    height: "16px",
    ...shorthands.flex("none"),
    order: 0,
    flexGrow: 0,
  },
  feedbackHeading: {
    width: "262px",
    height: "14px",
    fontFamily: "Segoe UI",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "14px", // match font size for tight header
    color: "#666666",
    ...shorthands.flex("none"),
    order: 0,
    alignSelf: "stretch",
    flexGrow: 0,
  },
  thumbsRate: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    ...shorthands.padding("0px"),
    ...shorthands.gap("2px"),
    width: "34px",
    height: "16px",
    ...shorthands.flex("none"),
    order: 1,
    flexGrow: 0,
  },
});
export function FeedbackButtons({ message, onFeedback }) {
  const [feedbackState, setFeedbackState] = useState({
    likeHovered: false,
    likeClicked: false,
    dislikeHovered: false,
    dislikeClicked: false,
  });

  const styles = useStyles();

  const handleFeedback1 = (messageId, feedbackType) => {
    console.log(`Feedback type: ${feedbackType} for message: ${messageId}`);

    // Check if the feedback button is already clicked
    if (feedbackType === "up" && feedbackState.likeClicked) {
      return;
    } else if (feedbackType === "down" && feedbackState.dislikeClicked) {
      return;
    }

    // Call the onFeedback function with the messageId and feedbackType
    onFeedback(messageId, feedbackType);
  };

  const handleLikeClick = () => {
    setFeedbackState((prevState) => ({
      ...prevState,
      likeHovered: false,
      likeClicked: true,
      dislikeHovered: false,
      dislikeClicked: false,
    }));
    message.positiveFeedback = true;
    message.negativeFeedback = false;
    // We handle feedback submisson from ChatMessage now
    //handleFeedback1(message.messageId, "up");
  };

  const handleDislikeClick = () => {
    setFeedbackState((prevState) => ({
      ...prevState,
      likeHovered: false,
      likeClicked: false,
      dislikeHovered: false,
      dislikeClicked: true,
    }));
    message.positiveFeedback = false;
    message.negativeFeedback = true;
    //handleFeedback1(message.messageId, "down");
  };

  return (
    <div className={styles.feedbackContainer}>
      <Label className={styles.feedbackHeading}>How did I do?</Label>
      <div className={styles.thumbsRate}>
        {feedbackState.likeClicked ? (
          <ThumbLikeFilled
            className={styles.iconStyle}
            onMouseEnter={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                likeHovered: true,
              }))
            }
            onMouseLeave={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                likeHovered: false,
              }))
            }
            onClick={handleLikeClick}
          />
        ) : (
          <ThumbLikeRegular
            className={styles.iconStyle}
            onMouseEnter={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                likeHovered: true,
              }))
            }
            onMouseLeave={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                likeHovered: false,
              }))
            }
            onClick={handleLikeClick}
          />
        )}

        {feedbackState.dislikeClicked ? (
          <ThumbDislikeFilled
            className={styles.iconStyle}
            onMouseEnter={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                dislikeHovered: true,
              }))
            }
            onMouseLeave={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                dislikeHovered: false,
              }))
            }
            onClick={handleDislikeClick}
          />
        ) : (
          <ThumbDislikeRegular
            className={styles.iconStyle}
            onMouseEnter={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                dislikeHovered: true,
              }))
            }
            onMouseLeave={() =>
              setFeedbackState((prevState) => ({
                ...prevState,
                dislikeHovered: false,
              }))
            }
            onClick={handleDislikeClick}
          />
        )}
      </div>
    </div>
  );
}

FeedbackButtons.propTypes = {
  message: PropTypes.object.isRequired,
  onFeedback: PropTypes.func.isRequired,
};
